import { useMutation, useQueryClient } from "react-query";
import { uploadImage } from "../../../services/media";
import { useContext } from "react";
import { ToastContext } from "../../context";

export const useUploadImageMutation = ({ onSuccess = () => {} }) => {
  const queryClient = useQueryClient();
  const triggerToast = useContext(ToastContext);
  const mutation = useMutation((data) => uploadImage(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getUploadedImage"]);
    },
  });

  const handleUploadMedia = (document, fileName) => {
    if (!document) return onSuccess({ url: "", file_name: "" });

    const formData = new FormData();
    formData.append("file", document);

    mutation.mutate(
      { formData },
      {
        onSuccess: (res) => {
          onSuccess({ url: res?.data?.data?.url, file_name: fileName });
          triggerToast("Document uploaded successfully", "success");
        },
      },
    );
  };

  return { ...mutation, handleUploadMedia };
};
